<template>
  <div
    class="checkout-tile payment-tile"
    :id="'js-' + method.type"
    v-if="method"
    :class="['input-type-radio ', 'js-' + method.type, method.type]"
  >
    <input
      @click="selectMethod(method)"
      type="radio"
      :id="method.type"
      name="paymentMethod"
      class="input-radio required"
      :class="[method.type]"
      :checked="isSelected"
      :data-required-text="resources.error"
      v-if="!readOnly"
    />

    <label :for="method.type"
      :class="'checkout-payment-radio' + [readOnly ? ' readonly' : '']">
      <span class="tile-title">
        <span v-if="!isCreditCardInReadOnlyMode(method)" class="ico" :class="['pay-' + calculateIcon(method)]"></span>
        <span v-else>
          <img class="creditcard-image" :src="calculateIcon(method)"/>
        </span>
        {{getMethodName(method)}}
        <span v-if="showAmazonPaymentDescriptor(method)" class="payment-descriptor">
          {{paymentDescriptor}}
        </span>
      </span>

      <component
        v-if="isSelected"
        v-bind:is="methodTileType"
        :method="method"
        :methodId="method.type"
        :readOnly="readOnly"
        @selected="selectMethod(method, $event)"
      />
    </label>
  </div>
</template>

<script src='./payment-method-tile.js'></script>
